document.addEventListener('DOMContentLoaded', () => {
    const menuBtn = document.querySelector('.menu-button');
    const iconContainer = menuBtn.querySelector('.icon');
    const modalMenu = document.querySelector('.modal');
    const menuItem = document.querySelectorAll('.menu-list-item');
    const header = document.querySelector('.header');
  
    let isMenuOpen = false;
  
    const burgerIcon = `
<svg width="28" height="22" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.5 1.5H26.1667M1.5 10.75H26.1667M1.5 20H26.1667" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
</svg>
    `;
  
    const crossIcon = `
<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M33.4149 5.69082C33.678 5.51541 33.9937 5.43661 34.3083 5.46784C34.6229 5.49908 34.9169 5.63843 35.1403 5.86214C35.3637 6.08585 35.5026 6.3801 35.5334 6.69475C35.5642 7.0094 35.4849 7.32499 35.3091 7.58776L35.1342 7.80096L22.4324 20.5L35.1342 33.2018L35.3091 33.415C35.4833 33.6778 35.5613 33.9928 35.5298 34.3066C35.4983 34.6203 35.3593 34.9135 35.1363 35.1364C34.9134 35.3594 34.6202 35.4984 34.3065 35.5299C33.9927 35.5614 33.6778 35.4834 33.4149 35.3092L33.2017 35.1343L20.4999 22.4325L7.80087 35.1343C7.6748 35.2648 7.52399 35.3689 7.35725 35.4406C7.19051 35.5122 7.01118 35.5499 6.82971 35.5515C6.64825 35.553 6.46829 35.5185 6.30033 35.4497C6.13237 35.381 5.97978 35.2795 5.85146 35.1512C5.72314 35.0229 5.62166 34.8703 5.55294 34.7024C5.48423 34.5344 5.44965 34.3544 5.45122 34.173C5.4528 33.9915 5.4905 33.8122 5.56213 33.6454C5.63375 33.4787 5.73787 33.3279 5.8684 33.2018L18.5675 20.5L5.8684 7.80096L5.69073 7.58776C5.51369 7.32479 5.43356 7.00846 5.46408 6.69292C5.4946 6.37739 5.63386 6.08227 5.85802 5.85811C6.08218 5.63395 6.3773 5.49469 6.69283 5.46417C7.00837 5.43366 7.3247 5.51378 7.58767 5.69082L7.80087 5.86849L20.4999 18.5676L33.2017 5.86849L33.4149 5.69082Z" fill="black" />
</svg>
    `;
  
    menuBtn.addEventListener('click', () => {
      isMenuOpen = !isMenuOpen;
      iconContainer.innerHTML = isMenuOpen ? crossIcon : burgerIcon;
      isMenuOpen ? openModal() : closeModal();
    });
  
    menuItem.forEach(item =>
      item.addEventListener('click', () => {
        closeModal();
        iconContainer.innerHTML = burgerIcon;
        isMenuOpen = false;
      })
    );
  
    window.addEventListener('scroll', blurHeader);
  
    function openModal() {
      modalMenu.style.display = 'block';
    }
  
    function closeModal() {
      modalMenu.style.display = 'none';
    }
  
    function blurHeader() {
      if (!header) return;
      if (window.scrollY > 60) {
        header.classList.add('header-scroll');
      } else {
        header.classList.remove('header-scroll');
      }
    }
  });